var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.containerClass },
    [
      _vm.showBackButton
        ? _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.getLabelTooltip,
                placement: "bottom-start",
                arrow: false,
                disabled: !_vm.showTooltip
              }
            },
            [
              _c("CompassIconButton", {
                attrs: { icon: "caret-left" },
                on: { click: _vm.handleClick }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPrefixColoredIcon
        ? _c("CompassColoredIcon", {
            staticClass: "heading__icon",
            attrs: {
              icon: _vm.prefixColoredIcon.icon,
              color: _vm.prefixColoredIcon.color,
              size: _vm.iconSize
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_vm.variant, { tag: "component", class: _vm.fontClass }, [
        _vm._v("\n        " + _vm._s(_vm.labelTitle) + "\n    ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }